// Currency conversion rates (simplified - in production, use a real API)
const CURRENCY_RATES = {
  USD: 1,
  EUR: 0.85,
  GBP: 0.73,
  NGN: 750, // Nigerian Naira
  KES: 150, // Kenyan Shilling
  GHS: 12, // Ghanaian Cedi
  ZAR: 18, // South African Rand
  EGP: 30, // Egyptian Pound
  MAD: 10, // Moroccan Dirham
  TND: 3.1, // Tunisian Dinar
  DZD: 135, // Algerian Dinar
  XOF: 600, // West African CFA Franc
  XAF: 600, // Central African CFA Franc
  CDF: 2000, // Congolese Franc
  UGX: 3700, // Ugandan Shilling
  TZS: 2400, // Tanzanian Shilling
  MWK: 1200, // Malawian Kwacha
  ZMW: 20, // Zambian Kwacha
  BWP: 13, // Botswana Pula
  NAM: 13, // Namibian Dollar
  SZL: 18, // Swazi Lilangeni
  LSL: 18, // Lesotho Loti
  MUR: 45, // Mauritian Rupee
  SCR: 13, // Seychellois Rupee
  KMF: 450, // Comorian Franc
  DJF: 180, // Djiboutian Franc
  ETB: 55, // Ethiopian Birr
  SOS: 570, // Somali Shilling
  SDG: 600, // Sudanese Pound
  SSP: 600, // South Sudanese Pound
  ERN: 15, // Eritrean Nakfa
  BIF: 2000, // Burundian Franc
  RWF: 1200, // Rwandan Franc
  STN: 23, // São Tomé and Príncipe Dobra
  AOA: 800, // Angolan Kwanza
  CVE: 100, // Cape Verdean Escudo
  GMD: 60, // Gambian Dalasi
  GNF: 8500, // Guinean Franc
  LRD: 150, // Liberian Dollar
  SLL: 20000, // Sierra Leonean Leone
  MRO: 350, // Mauritanian Ouguiya
  MRU: 35, // Mauritanian Ouguiya (new)
  XPF: 110, // CFP Franc
  XCD: 2.7, // East Caribbean Dollar
  XAU: 0.0004, // Gold (troy ounce)
  XAG: 0.04, // Silver (troy ounce)
  XPT: 0.001, // Platinum (troy ounce)
  XPD: 0.001, // Palladium (troy ounce)
};

// Country to currency mapping
const COUNTRY_CURRENCY = {
  US: 'USD',
  GB: 'GBP',
  EU: 'EUR',
  NG: 'NGN', // Nigeria
  KE: 'KES', // Kenya
  GH: 'GHS', // Ghana
  ZA: 'ZAR', // South Africa
  EG: 'EGP', // Egypt
  MA: 'MAD', // Morocco
  TN: 'TND', // Tunisia
  DZ: 'DZD', // Algeria
  SN: 'XOF', // Senegal
  CI: 'XOF', // Ivory Coast
  CM: 'XAF', // Cameroon
  CD: 'CDF', // Democratic Republic of Congo
  UG: 'UGX', // Uganda
  TZ: 'TZS', // Tanzania
  MW: 'MWK', // Malawi
  ZM: 'ZMW', // Zambia
  BW: 'BWP', // Botswana
  NA: 'NAM', // Namibia
  SZ: 'SZL', // Eswatini
  LS: 'LSL', // Lesotho
  MU: 'MUR', // Mauritius
  SC: 'SCR', // Seychelles
  KM: 'KMF', // Comoros
  DJ: 'DJF', // Djibouti
  ET: 'ETB', // Ethiopia
  SO: 'SOS', // Somalia
  SD: 'SDG', // Sudan
  SS: 'SSP', // South Sudan
  ER: 'ERN', // Eritrea
  BI: 'BIF', // Burundi
  RW: 'RWF', // Rwanda
  ST: 'STN', // São Tomé and Príncipe
  AO: 'AOA', // Angola
  CV: 'CVE', // Cape Verde
  GM: 'GMD', // Gambia
  GN: 'GNF', // Guinea
  LR: 'LRD', // Liberia
  SL: 'SLL', // Sierra Leone
  MR: 'MRU', // Mauritania
  BF: 'XOF', // Burkina Faso
  ML: 'XOF', // Mali
  NE: 'XOF', // Niger
  TD: 'XAF', // Chad
  CF: 'XAF', // Central African Republic
  CG: 'XAF', // Republic of Congo
  GA: 'XAF', // Gabon
  GQ: 'XAF', // Equatorial Guinea
  GW: 'XOF', // Guinea-Bissau
  TG: 'XOF', // Togo
  BJ: 'XOF', // Benin
};

// Currency symbols
const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  NGN: '₦',
  KES: 'KSh',
  GHS: 'GH₵',
  ZAR: 'R',
  EGP: 'E£',
  MAD: 'MAD',
  TND: 'TND',
  DZD: 'DZD',
  XOF: 'CFA',
  XAF: 'FCFA',
  CDF: 'FC',
  UGX: 'USh',
  TZS: 'TSh',
  MWK: 'MK',
  ZMW: 'ZK',
  BWP: 'P',
  NAM: 'N$',
  SZL: 'E',
  LSL: 'L',
  MUR: '₨',
  SCR: '₨',
  KMF: 'CF',
  DJF: 'Fdj',
  ETB: 'Br',
  SOS: 'S',
  SDG: 'SDG',
  SSP: 'SSP',
  ERN: 'Nfk',
  BIF: 'FBu',
  RWF: 'FRw',
  STN: 'Db',
  AOA: 'Kz',
  CVE: '$',
  GMD: 'D',
  GNF: 'FG',
  LRD: 'L$',
  SLL: 'Le',
  MRU: 'UM',
};

// Format currency amount
const formatCurrency = (amount, currency) => {
  const symbol = CURRENCY_SYMBOLS[currency] || currency;
  
  if (amount >= 1000000) {
    return `${symbol}${(amount / 1000000).toFixed(1)}M+`;
  } else if (amount >= 1000) {
    return `${symbol}${(amount / 1000).toFixed(1)}K+`;
  } else {
    return `${symbol}${amount.toLocaleString()}+`;
  }
};

// Detect user's country and currency
const detectUserCurrency = () => {
  try {
    // Try to get country from browser locale
    const locale = navigator.language || navigator.language;
    const country = locale.split('-')[1]?.toUpperCase();
    
    if (country && COUNTRY_CURRENCY[country]) {
      return COUNTRY_CURRENCY[country];
    }
    
    // Fallback to USD
    return 'USD';
  } catch (error) {
    console.error('Error detecting currency:', error);
    return 'USD';
  }
};

// Convert USD amount to local currency
const convertToLocalCurrency = (usdAmount) => {
  const localCurrency = detectUserCurrency();
  const rate = CURRENCY_RATES[localCurrency] || 1;
  const convertedAmount = usdAmount * rate;
  
  return {
    amount: convertedAmount,
    currency: localCurrency,
    formatted: formatCurrency(convertedAmount, localCurrency),
    originalUSD: usdAmount
  };
};

export { convertToLocalCurrency, detectUserCurrency, formatCurrency }; 